import { Company } from '@/@data/company'
import { BoxPage } from '@/components/common/BoxPage'
import { SettingFinanceTable } from '@/components/finance/setting-finance/SettingFinanceTable'
import { useRouteQuery } from '@/hooks'
import { Card, CardContent } from '@mui/material'
import { useQuery } from '@tanstack/react-query'

export const SettingFinance = () => {
  const { __ } = useTranslator()
  const { searchQuery } = useRouteQuery()

  const params = useMemo(() => {
    return {
      page: searchQuery.get('page'),
      perPage: searchQuery.get('perPage'),
      contract_status: searchQuery.get('status'),
      contract_start_date: searchQuery.get('contract_start_date'),
      contract_end_date: searchQuery.get('contract_end_date'),
      keywords: searchQuery.get('keywords')
    }
  }, [searchQuery])

  const { data: dataCompany, refetch } = useQuery({
    ...Company.objects.paginateQueryFactory(params)
  })

  return (
    <BoxPage
      showBackButton={true}
      title={__('Setting Finance')}
      breadcrumbs={[{ label: __('Finance Management'), href: '/cms/finance/balance' }, { label: __('Setting Finance') }]}
    >
      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ padding: 0 }}>
          <SettingFinanceTable
            data={dataCompany?.data || []}
            meta={dataCompany?.meta}
            onSuccess={() => {
              refetch()
            }}
          />
        </CardContent>
      </Card>
    </BoxPage>
  )
}
